/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import styled from 'styled-components';
import { isMobile, useConfig } from '@hooks';
import { useTranslation } from 'react-i18next';
import MenuSlider from './MenuSlider';

const ImgWP = styled.img`
  width: 31px;
`;

const FloatingWhatsApp = () => {
  const { config } = useConfig();
  const wapNumber = config?.help?.whatsappNumber;

  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };

  const { t } = useTranslation();

  const handleSubmit = () => {
    setTimeout(() => {
      if (isMobile()) {
        const mensaje = `whatsapp://send?phone=${wapNumber}&text=${t('floatingWhatsApp.menssage')}`;
        window.open(mensaje, '_blank', 'noopener');
      } else {
        const mensaje = `https://web.whatsapp.com/send?phone=${wapNumber}&text=${t(
          'floatingWhatsApp.menssage'
        )}`;
        window.open(mensaje, '_blank', 'noopener');
      }
    }, 1500);
  };

  return (
    <>
      {open && <MenuSlider closeMenu={() => setOpen(false)} handleClick={() => handleSubmit()} />}
      <div
        onClick={toggleOpen}
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
        id="whatsapp-need-help"
      >
        <ImgWP src="wp.svg" />
      </div>
    </>
  );
};

export default FloatingWhatsApp;
